import React, { Component } from 'react';
import { AppContext } from '../context/AppContext';

class MyOffersPage extends Component {
  static contextType = AppContext;

  render() {
    const { state } = this.context;
    return (
      <div className="simple-page">
        <div className="simple-page-card">
          <h2>המבצעים שלי</h2>
          <p>עסק נבחר: {state.selectedBusinessId || 'לא נבחר עסק'}</p>
        </div>
      </div>
    );
  }
}

export default MyOffersPage;